<template>
  <background-video />

  <sheet-modal  v-model="modals.confirmModal" exact-width="w-[423px]"
                scrollable icon="check-circle" :title="heading" :subtitle="text"
                blocking :has-confirm="!!purchasingPlanCode" confirm-label="checkout_continue" @confirm="goToCheckout">
    <account-profile v-if="confirmSuccess && !purchasingPlanCode" />
  </sheet-modal>

  <sheet-modal v-model="modals.languagePickerModal" :title="$t('languagepicker_title')" exact-width="w-[400px]" blocking>
    <language-picker :initial="user.language" @select="updateUserLanguage"></language-picker>
  </sheet-modal>

  <main-footer></main-footer>
  
</template>

<script>
// @ is an alias to /src
import MainFooter from '@/components/MainFooter.vue';
import AuthService from '../services/auth.service';
import BackgroundVideo from "@/components/ui/BackgroundVideo.vue";
import SheetModal from "@/components/ui/SheetModal.vue";
import AccountProfile from "@/components/account/AccountProfile.vue";
import {mapMutations, mapState} from "vuex";
import LanguagePicker from "@/components/session/LanguagePicker.vue";
import emitter from "@/services/emitter.service";

export default {
  name: 'AccountConfirm',
  components: {
    LanguagePicker,
    SheetModal,
    BackgroundVideo,
    MainFooter,
    AccountProfile,
  },
  data() {
    return {
      errors: {},
      confirmSuccess: false,
      confirmError: false,
      error: false,
      token: "",
      code: "",
      email: "",
      modals: {
        confirmModal: false,
        languagePickerModal: false,
      }
    }
  },
  methods: {
    ...mapMutations('nonpersist', ['setUserLanguage']),
    showModal(modalName) {
      this.modals[modalName] = true;
    },
    updateUserLanguage(language) {
      this.setUserLanguage(language);
      this.showModal('confirmModal');
      console.log(this.modals)
    },
    goToCheckout() {
      this.$router.replace('/plans?go=checkout');
    }
  },
  computed: {
    ...mapState('auth', ['token', 'purchaseType', 'purchasingPlanCode', 'purchaseInitiated', 'authorized']),
    ...mapState('nonpersist', ['user']),
    heading: function () {
      let title = this.$t('profile_account_activated');
      if (this.purchasingPlanCode) {
        title = this.$t('account_activated_wo_plan');
      }

      return title;
    },
    text: function () {
      let text = this.$t('profile_account_activated_text');
      if (this.purchasingPlanCode) {
        text = this.$t('account_activated_wo_plan_redirect');
      }
      return text;
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    this.code = this.$route.query.code;
    this.email = this.$route.query.email;

    AuthService.confirmAccount(this.code, this.token, this.email).then(
        (response) => {
          const token = response.data.result.token;
          this.$store.dispatch("auth/userMe", {
            token: token,
            room: false
          }).then(() => {
            this.confirmSuccess = true;
            this.showModal('confirmModal');
          });
        },
        (error) => {
          if (error.response.data.error === "user_is_already_activated") {
            this.confirmSuccess = true;

          } else {
            this.confirmError = true;
            this.error = error.response.data.error;
          }

          this.showModal('confirmModal');
        }
    ).finally(() => {
      console.log(this.authorized)
      if (this.purchasingPlanCode && !this.error) {
        setTimeout(() => {
          this.goToCheckout()
        }, 2000)
      }
    });

    emitter.on('open-language-picker-popup', () => {
      this.showModal('languagePickerModal');
    });
  }
}
</script>

<style lang="scss">
  .black-centered {
    background: var(--layer-1, #0F161A) !important;
    border-radius: 20px;
    border: 1px solid var(--stroke-separator, rgba(255, 255, 255, 0.08)) !important;
    background: var(--layer-1, #0F161A);

    &-header {
      margin-bottom: 28px;
    }

    &-content {
      text-align: center;

      h1 {
        color: #FFFFFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 30px; /* 125% */
        letter-spacing: -0.48px;
        margin: 0 8px;
      }

      p {
        color: rgba(255, 255, 255, 0.75);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
      }
    }
  }

  .center-logo {
    max-width: 90%;

    img {
      max-width: 100%;
    }
  }
</style>
